(() => {
  'use strict';
  const init = (root=document) => {
    root.querySelectorAll('[data-build-catalog]').forEach(scope => {
      if(scope.dataset.catalogReady)return;
      scope.dataset.catalogReady='true';
      const cards=[...scope.querySelectorAll('[data-gta-tier]')];
      const buttons=[...scope.querySelectorAll('[data-gta-filter]')];
      const more=scope.querySelector('[data-build-more]');
      const less=scope.querySelector('[data-build-less]');
      const status=scope.querySelector('[data-build-status]');
      const grid=scope.querySelector('.gta-build-grid');
      let filter='all', limit=4;
      const matches=(card,key)=>card.dataset.gtaTier.split(' ').includes(key);
      const notes={all:'Choose a GPU on configurable builds.',entry:'Configurations under $2,500 CAD.',balanced:'Available NVIDIA RTX configurations.',premium:'Configurations from $3,500 CAD, including our flagships.'};
      buttons.forEach(button=>{
        button.querySelector('[data-build-count]').textContent=cards.filter(c=>matches(c,button.dataset.gtaFilter)).length;
        button.addEventListener('click',()=>{
          filter=button.dataset.gtaFilter;limit=4;
          buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
          cards.forEach(card=>{
            const select=card.querySelector('[data-gk-variant]');
            const variant=card.getAttribute('data-variant-'+filter);
            if(select&&variant){select.value=variant;select.dispatchEvent(new Event('change',{bubbles:true}));}
          });
          grid.scrollLeft=0;
          render();
        });
      });
      function render(){
        const matching=cards.filter(c=>matches(c,filter));
        cards.forEach(c=>{const i=matching.indexOf(c);c.hidden=i<0||i>=limit;});
        status.textContent=`Showing ${Math.min(limit,matching.length)} of ${matching.length} builds · ${notes[filter]}`;
        more.hidden=limit>=matching.length;
        more.textContent=`Show ${Math.min(4,Math.max(0,matching.length-limit))} more builds`;
        less.hidden=limit<=4;
      }
      more.addEventListener('click',()=>{limit+=4;render();});
      less.addEventListener('click',()=>{limit=4;grid.scrollLeft=0;render();scope.scrollIntoView({block:'start',behavior:'auto'});});
      render();
    });
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init()):init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  if(!document.body.hasAttribute('data-preview'))return;
  document.querySelectorAll('.gk-cart-link').forEach(a=>a.href='cart.html');
  const fmt=n=>new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'}).format(Number(n));
  const getCart=()=>{try{return JSON.parse(sessionStorage.getItem('gta-preview-cart')||'null')}catch{return null}};
  const updateCount=()=>document.querySelectorAll('.gk-cart-link').forEach(a=>a.textContent=`Cart (${getCart()?.quantity||0})`);
  updateCount();
  const select=document.querySelector('[data-gta-product-variant]');
  if(select)fetch('products.json').then(r=>r.json()).then(products=>{
    const query=new URLSearchParams(location.search),idx=Math.max(0,Math.min(products.length-1,Number(query.get('build'))||0)),p=products[idx];
    const variants=p.variants.nodes.filter(v=>v.availableForSale);
    const initial=variants.find(v=>v.id.endsWith('/'+query.get('variant')))||p.selected;
    const image=document.querySelector('[data-gta-product-image]');image.src=p.image+'&width=1000';image.alt=p.title;
    document.querySelector('[data-gta-product-title]').textContent=p.title;
    document.querySelector('[data-gta-product-specs]').textContent=p.specs;
    variants.forEach(v=>{const o=document.createElement('option');o.value=v.id;o.textContent=v.title==='Default Title'?'RTX 5090 32GB':v.title.replace(/\s*\(.*/,'');o.selected=v.id===initial.id;select.append(o)});
    const refresh=()=>{
      const v=variants.find(v=>v.id===select.value);
      document.querySelector('[data-gta-price]').textContent=fmt(v.price);
      const cmp=document.querySelector('[data-gta-compare]');cmp.textContent=fmt(v.compareAtPrice||0);cmp.hidden=!(Number(v.compareAtPrice)>Number(v.price));
      document.querySelector('[data-gta-live-product]').href='https://groovycomputers.ca/products/'+encodeURIComponent(p.handle)+'?variant='+v.id.split('/').pop();
      document.querySelector('[data-gta-cart-status]').textContent='';
    };
    select.addEventListener('change',refresh);refresh();
    document.querySelector('[data-gta-preview-add]').addEventListener('click',()=>{
      const v=variants.find(v=>v.id===select.value);sessionStorage.setItem('gta-preview-cart',JSON.stringify({title:p.short,image:p.image,variant:select.selectedOptions[0].textContent,price:v.price,quantity:1}));
      document.querySelector('[data-gta-cart-status]').textContent='Added to the preview cart. No live order placed.';updateCount();
    });
  }).catch(()=>{document.querySelector('[data-gta-cart-status]').textContent='Product details could not load. Refresh this preview.'});
  const cart=document.querySelector('[data-gta-preview-cart]');
  if(cart){const item=getCart();if(!item){const p=document.createElement('p');p.className='gta-body-copy';p.textContent='Your preview cart is empty. Explore a PC and choose your configuration.';cart.append(p)}else{
    const row=document.createElement('div');row.className='gta-cart-row';const image=document.createElement('img');image.src=item.image;image.alt=item.title;const info=document.createElement('div');const title=document.createElement('h3');title.textContent=item.title;const variant=document.createElement('p');variant.textContent=item.variant+' · Quantity '+item.quantity;info.append(title,variant);const price=document.createElement('strong');price.textContent=fmt(item.price)+' CAD';row.append(image,info,price);cart.append(row);
  }}
})();
